/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentDto } from '../../models/content-dto';
import { CreateContentDto } from '../../models/create-content-dto';

export interface AdminContentControllerUpdate$Params {
  id: string;
      body: CreateContentDto
}

export function adminContentControllerUpdate(http: HttpClient, rootUrl: string, params: AdminContentControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentDto>> {
  const rb = new RequestBuilder(rootUrl, adminContentControllerUpdate.PATH, 'patch');
  if (params) {
    rb.query('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentDto>;
    })
  );
}

adminContentControllerUpdate.PATH = '/api/content/admin/{id}';
